import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";

import { Simulation } from "../../../types/Simulation/simulation";

import { WrapperCard } from "./styles";
import { formatDate } from "../../../utils/formatDate";

// import { formatDate } from "../../../utils/formatDate";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data: Simulation;
}

export const CardResult: React.FC<Props> = ({ data }) => {
  const onClick = () => {
    console.log(data)
    let dadosComplementares = { "politicamenteExposta":false,"possuiRelacionamento":false, "PPE":{}, dataNascimento: data.dataNascimento};
    sessionStorage.setItem("@SimuladorSias.simulacao", JSON.stringify(data));
    sessionStorage.setItem("@SimuladorSias.dadosComplementares", JSON.stringify(dadosComplementares));
    window.location.href = '/dados-complementares';
  };

  useEffect(() => {
    console.log(data)
  },[data]);

  return (
    <WrapperCard>
      {data.tipoSimulador === 'R' ? (
        <Card>
          <Card.Body>
            <Card.Title>Renda Mensal</Card.Title>
            <Card.Subtitle>
              {data.valorBeneficio.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Card.Subtitle>
            <Card.Text>
              Para receber{' '}
              <strong>
                {data.valorBeneficio.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </strong>{' '}
              aos <strong>{data.idadeAposentadoria} anos</strong>, você terá que
              contribuir com{' '}
              <strong>
                {data.valorContribuicao.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </strong>{' '}
              por mês durante{' '}
              <strong>{data.descricaoTempoContribuicao}</strong>.
            </Card.Text>
            <Link className="btn" to="#!" onClick={onClick}>
              Quero esse
            </Link>
          </Card.Body>
        </Card>
      ) : (
        <Card>
          <Card.Body>
            <Card.Title>
              
            {data.valorBeneficio == 0 ?
            "Valor benefício pagamento único de" :
            "Sua renda mensal (provável) será de"
            }
            </Card.Title>
            <Card.Subtitle>
              {(data.valorBeneficio == 0 ? data.valorAVista : data.valorBeneficio).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
              
              {/* <span>
                Durante {data.prazoRecebRendaMeses.toLocaleString("pt-BR")}{" "}
                {data.prazoRecebRendaMeses === 1 ? "mês" : "meses"}.
              </span> */}
            </Card.Subtitle>
            <Card.Text>
              Investindo{" "}
              <strong> R${data.valorContribuicao.toLocaleString("pt-BR")}</strong>
              /mês por{" "}
              <strong>{data.descricaoTempoContribuicao.toLocaleString()}</strong>,
              com aporte inicial de R$
              {data.valorAporteInicial.toLocaleString("pt-BR")}. Vai acumular{" "}
              <strong>R$ {data.saldoBruto.toLocaleString("pt-BR")}</strong>
            </Card.Text>
            <Link className="btn" to="#!" onClick={onClick}>
              Quero esse
            </Link>
          </Card.Body>
        </Card>
      )}
      <Card className="more-details">
        <Card.Body>
            <Card.Title>Mais detalhes</Card.Title>Recebimento a partir do
            dia <strong> {formatDate(data.dataPrimeiroRecebimento)}</strong>,
            descontando o imposto {data?.ir?.tipo} no valor de{" "}
            <strong> R$ {(data?.ir?.valor ?? 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>{" "}
            aplicado a uma alíquota mensal de{" "}
            <strong>{data?.ir?.aliquota.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}% de IR</strong>.
        </Card.Body>
      </Card>
    </WrapperCard>
  );
};

export default CardResult;
